export const STORAGE_KEYS = {
  ACCESS_TOKEN: 'id_token',
  AUTH_REDIRECT: 'auth_redirect',
} as const;
